<div class="inline-label">
  @if (inputName && !(multiple && multipleAsSeparateInputs)) {
    <input
      #syncedInput
      type="hidden"
      [attr.name]="inputName"
      [value]="mappedInputValue"
      [attr.data-action]="hiddenFieldAction">
  }
  @if (multiple && multipleAsSeparateInputs) {
    @for (value of mappedInputValue; track value) {
      <input
        type="hidden"
        [attr.name]="inputName+'[]'"
        [attr.data-action]="hiddenFieldAction"
        [value]="value">
    }
  }
  <ng-select
    #ngSelectInstance
    [(ngModel)]="model"
    [items]="results$ | async"
    [ngClass]="classes"
    [typeahead]="typeahead"
    [clearOnBackspace]="clearOnBackspace"
    [clearSearchOnAdd]="clearSearchOnAdd"
    [hideSelected]="hideSelected"
    [appendTo]="appendTo"
    [multiple]="multiple"
    [loading]="loading$ | async"
    [addTag]="addTag"
    [virtualScroll]="virtualScroll"
    [required]="required"
    [clearable]="clearable"
    [closeOnSelect]="closeOnSelect"
    [openOnEnter]="openOnEnter"
    [disabled]="disabled"
    [name]="name"
    [id]="id"
    [attr.accesskey]="accesskey||undefined"
    [bindLabel]="bindLabel"
    [bindValue]="bindValue"
    [markFirst]="markFirst"
    [notFoundText]="notFoundText"
    [addTagText]="addTagText"
    [loadingText]="loadingText"
    [clearAllText]="clearAllText"
    [appearance]="appearance"
    [dropdownPosition]="dropdownPosition"
    [selectOnTab]="selectOnTab"
    [maxSelectedItems]="maxSelectedItems"
    [placeholder]="placeholder"
    [groupBy]="groupBy"
    [groupValue]="groupValue"
    [bufferAmount]="bufferAmount"
    [selectableGroup]="selectableGroup"
    [searchable]="searchable"
    [selectableGroupAsModel]="selectableGroupAsModel"
    [trackByFn]="trackByFn"
    [compareWith]="compareWith"
    [searchFn]="searchFn"
    [labelForId]="labelForId"
    [inputAttrs]="inputAttrs"
    [ariaLabel]="ariaLabel"
    [tabIndex]="tabIndex"
    [readonly]="readonly"
    [searchWhileComposing]="searchWhileComposing"
    [minTermLength]="minTermLength"
    [editableSearchTerm]="editableSearchTerm"
    [keyDownFn]="keyDownFn"

    (change)="changed($event)"
    (open)="opened()"
    (close)="closed()"
    (blur)="blured($event)"
    (focus)="focused($event)"
    (clear)="cleared($event)"
    (keydown)="keydowned($event)"
    (keydown.escape)="canceled($event)"
    (search)="searched($event)"
    (scroll)="scrolled($event)"
    (scrollToEnd)="scrolledToEnd($event)"
    (add)="added($event)"
    (remove)="removed($event)"
    >
    @if (headerTemplate || projectedHeaderTemplate) {
      <ng-template
        ng-header-tmp
        let-item="item"
        let-index="index"
        let-search="searchTerm"
      >
        <ng-container [ngTemplateOutlet]="headerTemplate || projectedHeaderTemplate"
          [ngTemplateOutletContext]="{$implicit:item, search:search, index:index }"
         />
      </ng-template>
    }

    @if (labelRequired) {
      <ng-template
        ng-label-tmp
        let-item="item"
        let-index="index"
        let-search="searchTerm"
        let-clear="clear"
      >
        <ng-container [ngTemplateOutlet]="projectedLabelTemplate || labelTemplate || defaultLabel"
          [ngTemplateOutletContext]="{$implicit:item, search:search, index:index, clear:clear }"
         />
      </ng-template>
    }

    <ng-template
      ng-option-tmp
      let-item="item"
      let-index="index"
      let-search="searchTerm"
    >
      <ng-container [ngTemplateOutlet]="projectedOptionTemplate || optionTemplate || defaultOption"
        [ngTemplateOutletContext]="{$implicit:item, search:search, index:index }"
       />
    </ng-template>

    @if (footerTemplate || projectedFooterTemplate) {
      <ng-template
        ng-footer-tmp
        let-item="item"
        let-index="index"
        let-search="searchTerm"
      >
        <ng-container [ngTemplateOutlet]="footerTemplate || projectedFooterTemplate"
          [ngTemplateOutletContext]="{$implicit:item, search:search, index:index }"
         />
      </ng-template>
    }
  </ng-select>
</div>

<ng-template let-item let-search="search" #defaultOption>
  @switch (true) {
    @case (!resource && !!item.depth) {
      <span [ngOptionHighlight]="search"
        [textContent]="item.name"
        [ngStyle]="{'padding-left.px': item.depth * 16}"
        class="ng-option-label ellipsis">
      </span>
    }
    @case (resource === 'work_packages' || resource === 'parent-child') {
      <div class="op-autocompleter--option-wrapper" title="{{ item.subject }}">
        @if (item.author && item.author.href) {
          <op-principal class="op-autocompleter--option-principal"
            [principal]="item.author"
            [hideName]="true"
           />
        }
        <span
          class="op-autocompleter--wp-subject"
          data-test-selector="op-autocompleter-item-subject"
          >
          @if (item.type) {
            <span
              [ngClass]="highlighting('type', item.type.id)"
              textContent="{{ item.type.name }} "
            ></span>
          }
          <span
            [ngOptionHighlight]="search"
            [textContent]="item.subject">
          </span>
        </span>
        <div class="op-autocompleter--wp-content">
          <span
            [ngOptionHighlight]="search"
            [textContent]="item.project?.name"
            class="op-autocompleter--wp-project"
          ></span>
          <span
            class="op-autocompleter--wp-id"
            [ngOptionHighlight]="search"
          >#{{ item.id }}</span>
          <span
            [textContent]="item.status?.name"
            [ngClass]="highlighting('status',item.status?.id)"
            class="op-autocompleter--wp-status"
          ></span>
        </div>
      </div>
    }
    @case (resource ==='users' || resource ==='assignee' || resource === 'principals') {
      @if (item && item.href) {
        <op-principal [principal]="item"
          [hideName]="true"
          class="op-autocompleter--option-principal-avatar"
          size="mini"
         />
      }
      <span
        [attr.data-hover-card-trigger-target]="getHoverCardTriggerTarget(item)"
        [attr.data-hover-card-url]="getHoverCardUrl(item)"
      [ngOptionHighlight]="search">{{ item.name }}</span>
      @if (item.email) {
        <span
          class="op-autocompleter__option-principal-email"
        [ngOptionHighlight]="search">{{ item.email }}</span>
      }
    }
    @case (resource ==='subproject' || resource ==='version' || resource ==='status' || resource ==='default' || (!resource && !item.depth)) {
      <span
        [ngClass]=" additionalClassProperty ? item[additionalClassProperty] : ''"
        [attr.data-hover-card-trigger-target]="getHoverCardTriggerTarget(item)"
        [attr.data-hover-card-url]="getHoverCardUrl(item)"
        [ngOptionHighlight]="search">{{ item.name }}
      </span>
      @if (item.email) {
        <span
          class="op-autocompleter__option-principal-email"
        [ngOptionHighlight]="search">{{ item.email }}</span>
      }
    }
  }
</ng-template>

<ng-template let-item let-search="search" let-clear="clear" #defaultLabel>
  @if (resource === 'work_packages') {
    <span class="ng-value-icon left" (click)="clear(item)">Ã</span>
    @if (item.id) {
      <span
        class="ng-value-label"
        [ngOptionHighlight]="search"
        >
        {{ item.type?.name }} #{{ item.id }} {{ item.subject || item.name }}
      </span>
    }
  }

  @if (resource !== 'work_packages') {
    <span class="ng-value-icon left" (click)="clear(item)">Ã</span>
    <span
      [ngOptionHighlight]="search"
      [ngClass]=" additionalClassProperty ? item[additionalClassProperty] : ''"
    class="ng-value-label">{{ item.name }}</span>
  }
</ng-template>
